export const CATEGORY_LEVEL = Object.freeze({
	ONE: 'ONE',
	TWO: 'TWO',
	THREE: 'THREE',
});
